<template>
  <div class="search">
    <el-form class="searchform" :class="{'search-hidden':search_hidden}" :style="{'height':search_height}" ref="form" :model="form" label-width="80px" label-position="left">
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">戶主名稱</label>
            <el-input v-model="form.name" clearable></el-input>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">身份証號碼</label>
            <el-input v-model="form.card" clearable></el-input>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">電話號碼</label>
            <el-input v-model="form.phone" clearable></el-input>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">戶主代號</label>
            <el-input v-model="form.code" clearable></el-input>
          </div>
        </div>
      </div>
      <div class="mm-submitbox">
        <div>
          <el-button type="primary" @click="submit" plain>清除</el-button>
          <el-button type="warning" @click="submit" plain>刷新</el-button>
        </div>
      </div>
    </el-form>
    <div @click="changesearchbox" class="rowline">
      <div>
        <i class="mm-nav-arrow el-icon-arrow-down" style="font-size: 12px; margin-right: 5px;"></i><span>{{search_hidden_text}}</span>
      </div>
    </div>

  </div>

</template>

<script>
export default {
	props:['form'],
  name: "Search",
  data () {
    return {
      search_height: 0,
      search_hidden: true,
      search_hidden_text: '檢索展開',
    }
  },
  methods: {
    submit () {
      this.form.name = "";
      this.form.card= "";
      this.form.phone= "";
      this.form.code= "";
      // this.$emit('submit', {});
    },
    changesearchbox () {
      let search_height = this.$refs.form.$el.scrollHeight + 'px';
      if (this.search_hidden) {
        this.search_hidden = false;
        this.search_hidden_text = '檢索隱藏';
        this.search_height = search_height;
        console.log();

      } else {
        this.search_hidden = true;
        this.search_hidden_text = '檢索展開'
        this.search_height = 0;
      }
    }
  }

}
</script>

<style scoped>
.search {
  margin: 20px 0;
}
.searchform {
  transition: height ease 0.3s;
  overflow: hidden;
}

.rowline {
  border-bottom: 1px solid #66b1ff;
  display: flex;
  justify-content: center;
  padding-bottom: 5px;
  color: #409eff;
  cursor: pointer;
}
.search-hidden {
  height: 0;
  overflow: hidden;
}
</style>
